import { constants } from '../../../helpers';
import {
  changeMastersImportFilterEndImportDate,
  changeMastersImportFilterStartImportDate,
  reportMastersImportFilterEndImportDateSelector,
  reportMastersImportFilterStartImportDateSelector,
} from '../../../state';
import { DateRangeFlexSalesProps } from '../../DateRangeFlexSales';
import ReportBusinessDateRangeFilter from '../../ReportFilters/filters/BusinessDateRangeFilter';

type BusinessDateRangeFilterProps = Pick<
  DateRangeFlexSalesProps<Date>,
  'spacing' | 'requiredIncomplete'
>;

const ImportDateRangeFilter = (props: BusinessDateRangeFilterProps) => (
  <ReportBusinessDateRangeFilter
    {...props}
    maxDate={constants.masterImportRangeMaxDate}
    startTextKey="toolbar.labels.fromDateImport"
    endTextKey="toolbar.labels.toDateImport"
    startDateSelector={reportMastersImportFilterStartImportDateSelector}
    endDateSelector={reportMastersImportFilterEndImportDateSelector}
    changeStartDateAction={changeMastersImportFilterStartImportDate}
    changeEndDateAction={changeMastersImportFilterEndImportDate}
  />
);

export default ImportDateRangeFilter;
